// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__yRRgk","icon":"style_icon__GAMs1","setIcon":"style_setIcon__2jggq","setIconActive":"style_setIconActive__2w3ab","link":"style_link__1eAau"};